import React from "react";
import { Button, Modal } from "antd";
import OverdueTable from "./tables/OverdueTable";
import DataOpsSampleModalHeader from "./DataOpsSampleModalHeader";
import "../Dashboard/CustomerSubmissionDetailModal.css";
import "../Dashboard/TestMetrics.css";

/**
 * Chart / row drill-down — export-API overdue subset.
 * Pass headerItems for the labeled Sample__Modal header (row click);
 * otherwise title/subtitle are used (chart click).
 */
export default function OverdueDrillDownModal({
  open,
  title,
  subtitle,
  headerItems = null,
  rows,
  loading = false,
  reasonLabelById = null,
  onClose,
}) {
  const tableRows = Array.isArray(rows) ? rows : [];
  const hasHeaderItems = Array.isArray(headerItems) && headerItems.length > 0;

  return (
    <Modal
      className="Sample__Modal DataOpsAnalytics__DrillDownModal"
      centered
      open={open}
      title={(
        <div className="DataOpsAnalytics__DrillDownHeader">
          {hasHeaderItems ? (
            <DataOpsSampleModalHeader items={headerItems} />
          ) : (
            <div className="DataOpsAnalytics__DrillDownHeaderText">
              <div className="DataOpsAnalytics__DrillDownTitle">{title || "Overdue breakdown"}</div>
              {subtitle ? (
                <div className="DataOpsAnalytics__DrillDownSubtitle">{subtitle}</div>
              ) : null}
            </div>
          )}
        </div>
      )}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Close
        </Button>,
      ]}
      width="80vw"
      destroyOnClose
    >
      <OverdueTable
        rows={tableRows}
        loading={loading}
        reasonLabelById={reasonLabelById}
        showExtendedColumns
      />
    </Modal>
  );
}
